export const EMAIL_FIELD_LIMIT = 60
export const DISPLAY_NAME_LIMIT = 200
export const PASSWORD_FIELD_LIMIT = 255
